module.exports = __webpack_public_path__ + "static/sport/bgi-h5.5679d09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/bgi-h5.jpg
// module id = /z0R
// module chunks = 0